import {
  AuthProvider as RealAuthProvider,
  useAuth as useRealAuth,
  getAccessToken as getRealAccessToken,
} from "@mimber/auth"
import {
  AuthProvider as MockAuthProvider,
  useAuth as useMockAuth,
  getAccessToken as getMockAccessToken,
} from "./auth.e2e-mock"

// Playwright's mocked tier (VITE_E2E_MOCK_AUTH=true) swaps in a fake auth
// provider to avoid a real Cognito session check. Statically foldable, so
// production builds (where this env var is never set) tree-shake the mock.
const useMockedAuth = import.meta.env.VITE_E2E_MOCK_AUTH === "true"

export const AuthProvider = useMockedAuth ? MockAuthProvider : RealAuthProvider
export const useAuth = useMockedAuth ? useMockAuth : useRealAuth
export const getAccessToken = useMockedAuth
  ? getMockAccessToken
  : getRealAccessToken
export * from "./FeatureToggleProvider"
